import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { useAdjustmentNoteLoaders } from "../../../../administration"
import { useFiscalDocumentLoaders } from "../../../../fiscal-documents"
import { useDeliveryOrderService } from "../../../services/deliveryOrderService"
import { useDeliveryService } from "../../../services/deliveryService"
import { DeliveryOrder } from "../../../state/types"
import { NoteGenerationType } from "../../types"

export const useActions = () => {
    const fiscalDocumentLoaders = useFiscalDocumentLoaders()
    const adjustmentNoteLoaders = useAdjustmentNoteLoaders()

    const { annulDeliveryOrder } = useDeliveryOrderService()
    const { cancelDeliveryItems } = useDeliveryService()

    const { closeModal } = useUIActions()

    const submitAnnulDeliveryOrder = async (deliveryOrderId: string) => {
        Emitter.emit(Event.DB_SUBMIT)

        try {
            await annulDeliveryOrder(deliveryOrderId)

            Emitter.emit(Event.DB_SUBMIT_DONE, false, false)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo anular la orden de entrega.')
        }
    }

    // The customer doesn't want the pending items anymore: they are cancelled from the operation with a credit note
    const submitCancelPendingItems = async (
        deliveryOrder: DeliveryOrder,
        noteType: NoteGenerationType
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        try {
            const { table, operationId } = deliveryOrder
            const itemsData = deliveryOrder.items
                .filter(item => item.deliveryStats.pending > 0)
                .map(item => ({
                    itemId: item.itemId,
                    cancelQuantity: item.deliveryStats.pending
                }))
            await cancelDeliveryItems(table, operationId, itemsData, noteType, deliveryOrder.id)

            const { loadOperationFiscalDocuments } = fiscalDocumentLoaders()
            await loadOperationFiscalDocuments(operationId, false)
            const { loadOperationAdjustmentNotes } = adjustmentNoteLoaders()
            await loadOperationAdjustmentNotes(operationId, false)

            Emitter.emit(Event.DB_SUBMIT_DONE, false, false)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo generar la nota de crédito.')
        }
    }

    return {
        submitAnnulDeliveryOrder,
        submitCancelPendingItems
    }
}
